import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophy05Small = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.67 2.29V.33H4.33v1.96h-4v3.55a2.756 2.756 0 001.13 2.58c.29.2.92.56 1.6.93V7.81c-.37-.21-.672-.387-.84-.5-.5-.332-.55-.73-.55-1.47v-2.2h2.66v7.5c.002.242.029.483.08.72a4.571 4.571 0 001.99 2.86l3.23 1.84c.552.315 1.12.602 1.7.86v2.57L6.92 22.3v1.37h10.16V22.3l-4.41-2.35v-2.46c.32-.15.83-.42 1.72-.93l3.22-1.84a4.54 4.54 0 001.99-2.81c.059-.252.09-.51.09-.77l-.02-7.5h2.66v2.2c0 .74-.06 1.13-.55 1.47-.16.11-.46.29-.83.49v1.54c.68-.37 1.3-.72 1.59-.92a2.757 2.757 0 001.13-2.58V2.29h-4zm-5.14 8.96a2.575 2.575 0 01-5.15 0h1.65a.925.925 0 101.85 0V9a.925.925 0 00-1.85 0H9.38V3.17h4.58v1.66h-2.93V6.6a2.41 2.41 0 01.93-.18 2.533 2.533 0 012.2 1.25A2.6 2.6 0 0114.53 9v2.25z"
        fill=""
      />
    </svg>
  )
);
SvgAchievementsTrophy05Small.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsTrophy05Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophy05Small;
